var exports = {
  "JC": "UserProfilePopout.module__role___QUFOaT",
  "s$": "UserProfilePopout.module__roleRemoveIcon___QUFOaT",
  "Bx": "UserProfilePopout.module__iconSmall___QUFOaT",
  "bc": "UserProfilePopout.module__profileCustomStatus___QUFOaT",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___QUFOaT",
  "ZB": "UserProfilePopout.module__profileDisplayName___QUFOaT",
  "yn": "UserProfilePopout.module__profileDataWarning___QUFOaT",
  "zF": "UserProfilePopout.module__profilePopoutCard___QUFOaT",
};

module.exports = exports;
